module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/usr/src/app/www/src/layout/index.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-102518938-1","head":false,"pageTransitionDelay":700},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
